module.exports = __webpack_public_path__ + "img/item20.a33bbb2f.png";